// extracted by mini-css-extract-plugin
export default {"popup":"Reponse_popup__pY4o2","popup_btn":"Reponse_popup_btn__u51NM"};